// Part 3 — the AI finale.
//
// One last spotlight over the floating AI launcher. Instead of a Finish
// button, the closing screen is an inline input: the operator asks the AI
// one real question about their book. Submitting routes the question into
// the existing ChatPanel (via the `setup-tour:ask-ai` CustomEvent); the
// parent watches for the AI's first response and then completes the tour +
// fires the one-time celebration. A quiet "Skip" retires the tour without
// forcing the ask.

import React from 'react';
import Spotlight from './Spotlight';
import { FINALE } from './revealStops';

export default function AiFinale({ onSubmit, onSkip, awaiting, errored }) {
  const [text, setText] = React.useState('');

  const submit = () => {
    const q = text.trim();
    if (!q || awaiting) return;
    onSubmit(q);
  };

  return (
    <Spotlight anchors={FINALE.anchors}>
      <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[10px] font-black uppercase tracking-widest text-indigo-600">✨ {FINALE.title}</span>
          <button onClick={onSkip} className="text-[11px] text-slate-400 hover:text-slate-700 font-medium">Skip</button>
        </div>
        <p className="text-sm text-slate-800 leading-snug">{FINALE.copy}</p>

        <label className="block text-xs font-semibold text-slate-700 mt-3 mb-1">{FINALE.inputLabel}</label>
        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); } }}
          placeholder={FINALE.inputPlaceholder}
          rows={2}
          disabled={awaiting}
          autoFocus
          className="w-full px-3 py-2 border-2 border-slate-200 rounded-lg text-sm focus:border-indigo-500 focus:outline-none resize-none disabled:bg-slate-50"
        />
        {errored && (
          <div className="text-[11px] text-rose-600 mt-1">The AI didn't answer that time — try asking again.</div>
        )}
        <button
          onClick={submit}
          disabled={!text.trim() || awaiting}
          className="w-full mt-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-slate-300 text-white font-bold text-sm py-2.5 rounded-lg transition-colors"
        >
          {awaiting ? 'Asking your AI…' : 'Ask my AI →'}
        </button>
      </div>
    </Spotlight>
  );
}
